import React from 'react';
import { Utensils, Cloud, CloudOff, WifiOff } from 'lucide-react';
import { useFoodContext } from '../../context';
import { useNetworkStatus } from '../../hooks';
import { formatDate } from '../../utils/helpers';

/**
 * Application Header Component
 */
const Header = () => {
  const {
    foods,
    googleDrive,
    isLoading
  } = useFoodContext();

  const isOnline = useNetworkStatus();

  return (
    <div className="text-center mb-8">
      <h1 className="text-4xl font-bold text-gray-800 mb-4 flex items-center justify-center gap-3">
        <Utensils className="text-green-600" />
        Gestion des Indices Glycémiques
        {googleDrive.isConnected && (
          <div className="flex items-center ml-4">
            {isLoading ? (
              <CloudOff className="w-6 h-6 text-orange-500 animate-pulse" />
            ) : (
              <Cloud className="w-6 h-6 text-green-500" />
            )}
          </div>
        )}
        {!isOnline && (
          <div className="flex items-center ml-4" title="Mode hors ligne">
            <WifiOff className="w-6 h-6 text-red-500" />
          </div>
        )}
      </h1>
      
      <p className="text-lg text-gray-600 max-w-2xl mx-auto">
        Recherchez, analysez et gérez l'impact glycémique de vos aliments avec{' '}
        <span className="font-semibold text-green-600">{foods.length}</span> produits référencés
        
        {googleDrive.isConnected && googleDrive.googleUser && (
          <span className="block text-sm text-green-600 mt-2">
            Synchronisé avec Google Drive ({googleDrive.googleUser.getName()})
            {googleDrive.lastSyncTime && (
              <span className="text-xs text-gray-500 ml-2">
                Dernière sync: {formatDate(googleDrive.lastSyncTime)}
              </span>
            )}
          </span>
        )}
      </p>

      {/* Loading indicator */}
      {isLoading && (
        <div className="mt-4">
          <div className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-700 rounded-lg">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-700 mr-2"></div>
            Synchronisation en cours...
          </div>
        </div>
      )}

      {/* Error indicator */}
      {googleDrive.error && (
        <div className="mt-4">
          <div className="inline-flex items-center px-4 py-2 bg-red-50 text-red-700 rounded-lg">
            <CloudOff className="w-4 h-4 mr-2" />
            Erreur de synchronisation
          </div>
        </div>
      )}

      {/* Offline indicator */}
      {!isOnline && (
        <div className="mt-4">
          <div className="inline-flex items-center px-4 py-2 bg-orange-50 text-orange-700 rounded-lg border border-orange-200">
            <WifiOff className="w-4 h-4 mr-2" />
            Mode hors ligne - Fonctionnalités limitées
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;